import { EventKind, type EventQueue } from '../events/EventQueue';

export class AudioDirector {
  private context: AudioContext | null = null;
  muted = false;
  destroy(): void { if (this.context) void this.context.close().catch(() => {}); this.context = null; }
  unlock(): void { if (this.context === null) this.context = new AudioContext(); if (this.context.state === 'suspended') void this.context.resume(); }
  process(events: EventQueue): void {
    if (this.muted || this.context === null || this.context.state !== 'running') return;
    let popIndex = 0;
    for (let id = 0; id < events.count; id += 1) {
      // 发射不再逐滴发声：水流是每秒 45 滴，逐滴一个方波音等于持续蜂鸣。
      // 「一滴水一个音」这个模型本身就错了——水流的声音是一条连续噪声，
      // 随喷射开关淡入淡出。归 Backlog T018（音效制作与接入）。
      if (events.kind[id] === EventKind.EntityDied) { this.tone(170 * Math.pow(1.05, popIndex++), 0.075, 0.045, 'triangle'); }
    }
  }
  private tone(frequency: number, duration: number, volume: number, wave: OscillatorType): void {
    if (this.context === null) return; const oscillator = this.context.createOscillator(); const gain = this.context.createGain();
    oscillator.type = wave; oscillator.frequency.value = frequency; gain.gain.setValueAtTime(volume, this.context.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.0001, this.context.currentTime + duration); oscillator.connect(gain).connect(this.context.destination); oscillator.start(); oscillator.stop(this.context.currentTime + duration);
  }
}
